import { render } from "./CssGroup.vue?vue&type=template&id=0c648928&ts=true"
import script from "./CssGroup.vue?vue&type=script&lang=ts"
export * from "./CssGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__